// extracted by mini-css-extract-plugin
export default {"about":"about_HvM6a","content":"content_ASqAx"};